export default function StockResult(){
    return(
        <h4>Stock results here</h4>
    )
}